import script from "./Page5.vue?vue&type=script&setup=true&lang=js"
export * from "./Page5.vue?vue&type=script&setup=true&lang=js"

import "./Page5.vue?vue&type=style&index=0&id=4e50fa4a&lang=less"

const __exports__ = script;

export default __exports__